import { useNotifications } from 'api/notifications/notifications.api'
import { t } from 'i18next'
import React, { ReactElement, useMemo, useState } from 'react'
import { useNavigate } from 'react-router'
import Datetime from 'utils/datetime/datetime'
import EventPostViewModal from 'views/EventsView/components/EventPostViewModal/EventPostViewModal'
import { CustomTabPanel } from './components/CustomTabPanel'
import { EVENT_TAB_INDEX } from './NotificationCenter'
import { getNotificationItem, NotificationType, onLinkClicked } from './NotificationCenter.helper'
import styles from './NotificationCenter.module.less'

type NotificationEventTabProps = {
  selectedFilters: string[]
  date: ISODateTime
}

export default function NotificationEventTab({ selectedFilters, date }: NotificationEventTabProps): ReactElement {
  const [openEventPostViewModal, setOpenEventPostViewModal] = useState(false)
  const [selectedEventPostID, setSelectedEventPostID] = useState<number | undefined>(undefined)
  const navigate = useNavigate()
  const { data: eventResponse } = useNotifications({
    startTime: Datetime.getStartOfDay(date),
    endTime: Datetime.getEndOfDay(date),
    type: '',
    exclude: 'optimization',
  })
  function openEventModal(selectedEventPostID: number | undefined): void {
    setSelectedEventPostID(selectedEventPostID)
    setOpenEventPostViewModal(true)
  }

  const filteredEventItems: NotificationType[] = useMemo(() => {
    const filterEvent = (item: NotificationType) => {
      if (selectedFilters.length === 0) return true
      return selectedFilters.every((filter) => {
        if (filter === 'sent') {
          return item.type === 'OperationalEventSent'
        }
        if (filter === 'active') {
          return item.type === 'OperationalEventActivated'
        }
        if (filter === 'inactive') {
          return item.type === 'OperationalEventDeactivated'
        }
        if (filter === 'deleted') {
          return item.type === 'OperationalEventDeleted'
        }
        return false
      })
    }

    return eventResponse?.filter(filterEvent) || []
  }, [eventResponse, selectedFilters])
  return (
    <div>
      <CustomTabPanel index={EVENT_TAB_INDEX}>
        <div className={styles.NotificationCenter_Body}>
          <div className={styles.NotificationCenter_Events}>
            {filteredEventItems.length !== 0 ? (
              filteredEventItems.map((item, index) => {
                const eventLogItem = getNotificationItem(
                  item,
                  (route) => onLinkClicked(route, navigate),
                  openEventModal
                )
                return <div key={index}>{eventLogItem}</div>
              })
            ) : (
              <div className={styles.NotificationCenter_Events__noEvents}>{t('No events')}</div>
            )}
          </div>
        </div>
      </CustomTabPanel>
      {openEventPostViewModal && (
        <EventPostViewModal
          closeModal={() => setOpenEventPostViewModal(false)}
          selectedEventPostId={selectedEventPostID}
        />
      )}
    </div>
  )
}
